import { priceRequestService } from '../../services';

// initial state
const state = {
    all: [],
};

// getters
const getters = {};

// actions
const actions = {
    getAll ({ dispatch, commit }) {
        return priceRequestService
            .getAll()
            .then((nodes) => {
                commit('setNodes', nodes);

                return nodes;
            })
            .catch((error) => {
                commit('setNodes', []);
                dispatch('alert/error', error, { root: true });

                return error;
            });
    },
};

// mutations
const mutations = {
    setNodes (state, nodes) {
        state.all = nodes;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
